<div class="mx-auto flex w-full flex-col gap-y-4 bg-gray-400/5 p-8">
    <dd class="order-first text-3xl font-semibold tracking-tight text-gray-900 sm:text-5xl">{{properties.value}}</dd>
    <dt class="text-base leading-7 text-gray-600">{{metricTitle}}</dt>
</div>
